module.exports = __webpack_public_path__ + "img/thumbnail_SussexChicken_f_erythristic.245f9b7a.png";